/* MAY HOME — kart görsel galerisi (koleksiyon kartlarında görsel değiştirme) */
(function () {
  function show(gal, idx) {
    var imgs = gal.querySelectorAll('.mh-gal-img');
    if (!imgs.length) return;
    idx = (idx + imgs.length) % imgs.length;
    imgs.forEach(function (im, i) { im.classList.toggle('is-active', i === idx); });
    var dots = gal.querySelectorAll('.mh-gal-dot');
    dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    gal.dataset.i = idx;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mh-gal-nav, .mh-gal-dot');
    if (!btn) return;
    var gal = btn.closest('[data-gallery]');
    if (!gal) return;
    e.preventDefault();
    e.stopPropagation();
    var cur = parseInt(gal.dataset.i || '0', 10);
    if (btn.classList.contains('mh-gal-dot')) {
      show(gal, parseInt(btn.dataset.i || '0', 10));
    } else {
      show(gal, cur + (btn.classList.contains('mh-gal-next') ? 1 : -1));
    }
  });
})();
